<template>
  <div class="midAutumn-layout">
    <!-- ✅ 全局预加载层（放顶部） -->
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" name="fade">
      <div @touchmove.prevent class="preloading preloading-snail" v-show="count < 100 && !isPC">
        <div class="loading_bg">
          <div class="loading">
            <div class="loading_line"></div>
          </div>
          <div class="loading_text"></div>
          <div class="change_text">{{ Math.floor(count) }}%</div>
        </div>
      </div>
    </transition>

    <!-- ✅ 第二阶段：满屏漫画展示页 -->
    <transition name="fade">
      <div v-show="showComic && !isPC" class="comic-screen" @click="closeComic()">
        <img src="https://download4.qcplay.com/h5-images/active/snail/midAutumn/comic.png" class="comic-img" />
      </div>
    </transition>

    <div v-wechat-title="'《最强蜗牛》月光下的约定'"></div>

    <!-- ✅ 第三阶段：正式子页面内容 -->
    <div>
      <router-view :downloadApp="downloadApp" :showComicImg="showComicImg" :changeTab="goTo" :logger="logger" :showContent="showContent" />
    </div>

    <!-- tab 切换按钮 -->
    <div v-if="showTabs" class="section-tabs">
      <div class="tabs-box">
        <div v-for="(tab, index) in tabs" :key="index" class="tab-item" :class="['tab-' + tab.id, { active: isActive(tab.path) }]" @click="goTo(tab)"></div>
      </div>
    </div>
    <!-- 微信下载 -->
    <div class="wechat_download_wrap popup_wrap" v-show="wxLoadShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active" :duration="{ enter: 1000 }">
        <div class="wx_download_wrap_content" @click="wxLoadShow = false"></div>
      </transition>
      <div class="close-bg" v-if="wxLoadShow" @click="wxLoadShow = false"></div>
    </div>
  </div>
</template>

<script>
import { getTimeStamp, buriedLogger, wechatBrowser, analysisParams } from "@/utils/utils";
import { downloadApps } from "./api";

export default {
  name: 'Layout',
  components: {},
  data() {
    return {
      count: 20, // 预加载进度
      showComic: false,        // 是否显示漫画页
      showContent: false,      // 是否显示正式内容
      hasWatchedComic: false,   // 是否看过漫画（缓存控制用）
      isPC: false, // 是否PC端
      tabs: [
        { id: '1', label: '新服预约', path: 'anniversary' },
        { id: '2', label: '嫦娥营救计划', path: 'enter' },
        { id: '3', label: '运营活动', path: 'info' }
      ],
      logger: null,
      wxLoadShow: false,
      downloadUrls: {
        android_url: 'https://download4.qcplay.com/apk-v2/qc-kol-1168583.apk',
        ios_url: 'https://ad.qingcigame.com/v1/ad-click?game_id=39&os=iOS&company=qc&channel=kol&tag=1167888&optimizer_id=19&redirct=https://apps.apple.com/cn/app/id1507966188',
      },
      currentTab: '',
    };
  },
  mounted() {
    this.hasWatchedComic = localStorage.getItem('hasWatchedComic') === 'true';
    console.log('hasWatchedComic 状态：', this.hasWatchedComic);
  },
  created() {
    const isMobile = this.isMobile();

    if (!isMobile) {
      this.isPC = true;

      // ✅ 你有 PC 跳转控制时：
      if (!window.location.href.includes('pc')) {
        window.location.href = `https://h5.qingcigame.com/snail/midAutumn/pc${getTimeStamp()}`;
        return;
      }

      // 或者你不跳转，直接显示页面内容：
      this.showContent = true;
      return;
    }

    const midAutumn_loading = localStorage.getItem('midAutumn_loading')
    if (midAutumn_loading === 'true') {
      localStorage.setItem('midAutumn_loading', '')
      this.count = 100;
      this.showContent = true;
    } else {
      localStorage.setItem('midAutumn_loading', '')
      this.incrementTo100();
    }

    const bl = buriedLogger('snail', '中秋_layout');
    this.logger = bl;

    const params = analysisParams(window.location.href);
    const { download_id } = params;
    download_id && downloadApps({ download_id, title: 'title' }).then((res) => {
      if (res.code === 200) {
        this.downloadUrls = res.data
      }
    });
  },
  computed: {
    showTabs() {
      const currentPath = this.$route.path;
      return this.tabs.some(tab => currentPath.includes(tab.path));
    }
  },
  methods: {
    incrementTo100() {
      const target = 100;
      const duration = 3200; // 持续时间1秒
      const stepTime = duration / target; // 每一步的时间间隔
      const that = this;

      const intervalId = setInterval(() => {
        that.count += 1;
        if (that.count >= target) {
          clearInterval(intervalId); // 当达到100时停止计时器

          if (this.hasWatchedComic) {
            // ✅ 看过漫画：直接进入页面
            this.showContent = true;
          } else {
            // ✅ 第一次进入：展示漫画
            this.showComic = true;

            // 展示3秒后切换为主页面并保存缓存标记
            setTimeout(() => {
              this.showComic = false;
              this.showContent = true;

              // 👇 记录缓存，下次不再展示漫画
              localStorage.setItem('hasWatchedComic', 'true');
              this.hasWatchedComic = true;
            }, 3000);
          }
        }
      }, stepTime);
    },
    closeComic() {
      if (this.hasWatchedComic) {
        this.showComic = false;
      }
    },
    // 🔁 子页面按钮点击 → 再次调用此方法弹出漫画页
    openComicPage() {
      this.showComic = true;

      // 若你需要自动关闭，也可以继续添加 setTimeout
    },
    isMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(
        userAgent
      );
    },
    isActive(tabPath) {
      return this.$route.path.includes(`/midAutumn/${tabPath}`);
    },
    goTo(tab) {
      if (!this.isActive(tab.path)) {
        this.logger.sum('中秋tab_' + tab.label + '按钮');
        if (window.performance.navigation.type === 2) {
          localStorage.setItem('midAutumn_loading', 'true')
        }
        this.$router.push(`/midAutumn/${tab.path}`);
      }
    },
    downloadApp(callback) {
      const isWechat = wechatBrowser()
      if (isWechat) {
        callback ? callback() : this.wxLoadShow = true
      } else {
        const linkObj = this.downloadUrls
        const isIOS = navigator.userAgent.match(/(iPhone|iPod|ios)/i)
        const targetLink = isIOS ? linkObj.ios_url : linkObj.android_url

        if (targetLink) {
          setTimeout(() => {
            window.location.href = targetLink
          }, 200)
        }
      }
    },
    showComicImg() {
      this.showComic = true;
    },
  }
};
</script>

<style lang="less" scoped>
@import url('~@/assets/css/active.less');

.preloading-snail {
  width: 100%;
  height: 100%;
  background: url('https://download4.qcplay.com/h5-images/active/snail/midAutumn/preloading_bg.png')
    no-repeat;
  .bs(100%, 100%);
  z-index: 9999;

  .loading_bg {
    position: absolute;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    width: 628px;
    height: 32px;
    background: url('https://download4.qcplay.com/h5-images/active/snail/midAutumn/m_jdt.png')
      no-repeat;
    .bs(100%, 100%);
    display: flex;
    z-index: 21;

    .loading {
      position: absolute;
      height: 36px;
      width: 80px;
      overflow: hidden;
      animation: lineAnimation 3.3s forwards;

      .loading_line {
        position: absolute;
        width: 628px;
        height: 32px;
        border-radius: 60px;
        background: url('https://download4.qcplay.com/h5-images/active/snail/midAutumn/m_dt_sz.png')
          no-repeat;
        .bs(100%, 100%);

        .progress-text {
          position: absolute;
          top: -30px;
          left: 0;
          width: 100%;
          text-align: center;
        }
      }
    }

    .change_text {
      font-family: 'Noto Sans SC', sans-serif;
      font-size: 40px;
      font-weight: 700;
      color: white;
      text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black,
        1px 1px 0 black;
      line-height: 0px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      position: absolute;
      right: 0px;
      animation: lineTextAnimation 3.3s forwards;
    }

    .loading_text {
      .bs(100%, 100%);
      width: 291px;
      height: 33px;
      margin-left: -145.5px;
      bottom: -50px;
    }

    @keyframes lineTextAnimation {
      0% {
        width: 600px;
        /* 初始位置 */
      }

      100% {
        width: 65px;
        /* 目标位置 */
      }
    }

    @keyframes lineAnimation {
      0% {
        width: 0px;
        /* 初始位置 */
      }

      100% {
        width: 630px;
        /* 目标位置 */
      }
    }
  }
}

.comic-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  // height: 100%;
  height: 100vh;
  height: 100svh;
  background: #000;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.comic-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.section-tabs {
  position: fixed;
  bottom: 0;
  left: 50%;
  width: 750px;
  height: 118px;
  margin-left: -375px;
  display: flex;
  justify-content: space-between;
  background: url(https://download4.qcplay.com/h5-images/active/snail/midAutumn/bottom_nav_bg.png)
    no-repeat;
  background-size: 100% 100%;
  z-index: 98;

  .tabs-box {
    width: 712px;
    height: 96px;
    margin: 15px auto 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tab-item {
      width: 215px;
      height: 80px;
      cursor: pointer;
    }

    .tab-1 {
      background: url(https://download4.qcplay.com/h5-images/active/snail/midAutumn/nav_01_01.png)
        no-repeat;
      background-size: 100% 100%;
    }

    .tab-2 {
      background: url(https://download4.qcplay.com/h5-images/active/snail/midAutumn/nav_02_01.png)
        no-repeat;
      background-size: 100% 100%;
    }

    .tab-3 {
      background: url(https://download4.qcplay.com/h5-images/active/snail/midAutumn/nav_03_01.png)
        no-repeat;
      background-size: 100% 100%;
    }

    .tab-item.active {
      width: 248px;
      height: 96px;
    }

    .tab-1.active {
      background: url(https://download4.qcplay.com/h5-images/active/snail/midAutumn/nav_01_02.png)
        no-repeat;
      background-size: 100% 100%;
    }

    .tab-2.active {
      background: url(https://download4.qcplay.com/h5-images/active/snail/midAutumn/nav_02_02.png)
        no-repeat;
      background-size: 100% 100%;
    }

    .tab-3.active {
      background: url(https://download4.qcplay.com/h5-images/active/snail/midAutumn/nav_03_02.png)
        no-repeat;
      background-size: 100% 100%;
    }
  }
}

.wechat_download_wrap {
  .wx_download_wrap_content {
    background: url(https://download4.qcplay.com/h5-images/active/snail/midAutumn/download_bg.png)
      no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/snail/midAutumn/Layout.vue